import React, { useEffect, useState } from 'react';

import {
  Badge,
  Button,
  Collapse,
  Divider,
  Grid,
  Hidden,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Menu,
  Snackbar,
  Typography,
} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import useApi from '../../../../utils/useApi';
import './slideperfil.css';
import UIModalExit from '../../../UI/ModalExit/UIModalExit';
import SlideNotifications from '../Notifications/slideNotifications';

const MainSlidePerfil = ({ ...children }) => {
  const [expanded, setExpanded] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isClearing, setIsClearing] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [notificationLoad, notificationInfo] = useApi({
    method: 'get',
    params: { viewed: '0' },
    url: '/users/notifications',
  });

  const [notificationView] = useApi({
    method: 'get',
    url: '/users/notifications',
  });

  useEffect(() => {
    notificationLoad();
    // const interval = setInterval(() => notificationLoad(), 60000);
    // return () => {
    //   clearInterval(interval);
    // };
  }, []);

  function toggleExpandedCollapse() {
    setExpanded(!expanded);
  }

  function toggleDialog() {
    setOpenDialog(!openDialog);
  }

  function closeNotification(id, viewed, skipReload = false) {
    const params = { id, viewed };
    notificationView({
      params,
      onCompleted: () => {
        if (!skipReload) {
          notificationLoad();
        }
      },
    });
  }

  async function clearAllNotifications() {
    if (notificationInfo.data && notificationInfo.data.length > 0) {
      setIsClearing(true);
      setSnackbarOpen(true);
      handleClose(); // Fecha o menu de notificações

      const notificationsToClear = [...notificationInfo.data];

      for (let i = 0; i < notificationsToClear.length; i++) {
        const notification = notificationsToClear[i];
        closeNotification(notification.id, notification.viewed, true);

        // Delay de 500ms entre as requisições
        if (i < notificationsToClear.length - 1) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
      }

      // Recarrega uma única vez ao final
      notificationLoad();
      setIsClearing(false);
    }
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Grid className="main-base-slide-item">
        <Grid
          container
          direction="row"
          alignItems="center"
          justify={children.open ? 'flex-start' : 'center'}
          className="main-base-slide-perfil__item"
        >
          <Badge
            color="secondary"
            variant={notificationInfo.data !== null ? 'dot' : 'standard'}
            onClick={toggleExpandedCollapse}
          >
            {children.icon}
          </Badge>

          {/* sub-menu ao houver */}
          <Hidden xsUp={children.open}>
            <List
              component="div"
              disablePadding
              className="main-base-slide-perfil__submenu"
            >
              <span>{children.credencials?.name || 'Administrador'}</span>
              {children.options.map((option) => (
                <ListItem
                  onClick={option.exit ? toggleDialog : option.action}
                  key={children.options.indexOf(option) + 1}
                  button
                  style={{ padding: '5px 0px' }}
                >
                  <ListItemText primary={option.name} />
                </ListItem>
              ))}
            </List>
          </Hidden>

          <Hidden xsUp={!children.open}>
            <Grid
              container
              direction="column"
              className="main-base-slide-perfil__operador"
              onClick={toggleExpandedCollapse}
            >
              <span>
                {children.credencials?.name || 'Administrador'} {children.credencials?.lastName || ''}
              </span>
              <Typography paragraph>{children.credencials?.profile?.name || 'Administrador'}</Typography>
            </Grid>
          </Hidden>

          {children.open && <Grid item xs />}

          {/* noticações */}
          {children.open && (
            <IconButton
              onClick={handleClick}
              className="main-base-slide-perfil__notification-btn"
            >
              <Badge
                badgeContent={
                  notificationInfo.data === null
                    ? 0
                    : notificationInfo.data.length
                }
                color="secondary"
                overlap="circular"
                variant="standard"
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
          )}
        </Grid>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
          elevation={4}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          PaperProps={{
            style: {
              width: '380px',
              maxHeight: '500px',
              borderRadius: '12px',
              marginTop: '10px',
              boxShadow: '0px 8px 16px rgba(0,0,0,0.1)',
              overflowY: 'auto',
            },
          }}
        >
          <Grid container direction="column" className="main-base-slide-perfil__menu-content">
            <Grid
              container
              justify="space-between"
              alignItems="center"
              className="main-base-slide-perfil__menu-header"
            >
              <Typography className="main-base-slide-perfil__text-notification">
                Notificações
              </Typography>
              {notificationInfo.data && notificationInfo.data.length > 0 && (
                <Button
                  size="small"
                  onClick={clearAllNotifications}
                  className="main-base-slide-perfil__clear-all-btn"
                >
                  Limpar tudo
                </Button>
              )}
            </Grid>
            <Divider />
            <div className="main-base-slide-perfil__notifications-list">
              {notificationInfo.data === null && !notificationInfo.loading && (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ padding: '20px', textAlign: 'center' }}
                >
                  Nenhuma notificação nova por aqui.
                </Typography>
              )}
              {notificationInfo.loading && (
                <Typography
                  variant="body2"
                  color="textSecondary"
                  style={{ padding: '20px', textAlign: 'center' }}
                >
                  Carregando notificações...
                </Typography>
              )}

              {notificationInfo.data &&
                notificationInfo.data.map((notification, index) => (
                  <SlideNotifications
                    closeNotification={closeNotification}
                    handleClose={handleClose}
                    key={notification.id}
                    notification={notification}
                  />
                ))}
            </div>
          </Grid>
        </Menu>
        {children.open && (
          <Collapse
            in={expanded}
            timeout="auto"
            unmountOnExit
            style={{ width: '100%' }}
          >
            <List component="div" disablePadding>
              {children.options.map((option) => (
                <ListItem
                  onClick={option.exit ? toggleDialog : option.action}
                  key={children.options.indexOf(option) + 1}
                  button
                >
                  <ListItemText primary={option.name} />
                </ListItem>
              ))}
            </List>
          </Collapse>
        )}
      </Grid>
      <UIModalExit
        open={openDialog}
        toggleDialog={toggleDialog}
        exit={children.exit}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message="Limpando notificações em segundo plano... Você pode continuar utilizando o sistema normalmente."
      />
    </>
  );
};

export default MainSlidePerfil;
